var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"press"},[(_vm.loading > 0)?_c('div',[_c('h1',{staticStyle:{"text-align":"center","margin-top":"100px"}},[_vm._v("Redirecting...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }